import { Modal, Paper } from '@mui/material';
import { SavedView } from '@types';
import { useCallback, useState } from 'react';
import ShareButtonShareModalContents from './ShareButtonShareModalContents';
import ShareButtonViewsModalContents from './ShareButtonViewsModalContents';

export interface ShareButtonViewsModalProps {
  onClose: () => void;
  onSave: () => void;
}
const ShareButtonViewsModal = ({ onClose, onSave }: ShareButtonViewsModalProps) => {
  const [shareView, setShareView] = useState<null | SavedView>(null);
  const onShare = useCallback((view: SavedView) => {
    setShareView(view);
  }, []);
  const onCloseShareView = useCallback(() => {
    setShareView(null);
  }, []);
  return (
    <Modal open={true}>
      <Paper
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 900,
          height: 680,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          gap: 4,
          outline: 'none',
          minHeight: 0
        }}
      >
        {shareView ? (
          // Displayed when a view is selected for sharing
          <ShareButtonShareModalContents onClose={onCloseShareView} view={shareView} />
        ) : (
          // Displays a list of views to share / restore
          <ShareButtonViewsModalContents onShare={onShare} onClose={onClose} onSave={onSave} />
        )}
      </Paper>
    </Modal>
  );
};
export default ShareButtonViewsModal;
